import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClientePipeSharedModule } from '../../pipes';

import { ClienteAnaliseFinanceiraBtnOptionsComponent } from './cliente-analise-financeira-btn-options.component';

@NgModule({
    imports: [
        SharedModule,
        ClientePipeSharedModule
    ],
    declarations: [
        ClienteAnaliseFinanceiraBtnOptionsComponent
    ],
    exports: [
        ClienteAnaliseFinanceiraBtnOptionsComponent
    ]
})
export class ClienteAnaliseFinanceiraBtnOptionsModule { }
